<template>
  <div class="calculator">
    <div class="calculator-title">Compare Supernodes’ leasing rewards</div>
    <div class="calculator-card">
      <div class="calculator-top">
        <div class="calculator-amount">
          <p>Input the amount you’d like to stake</p>
          <el-popover
            placement="bottom"
            trigger="manual"
            v-model="popoverVisible"
          >
            <div><i class="el-icon-error" style="color: red; margin-right: 10px"></i>
              Please Enter Your Leasing Amount!
            </div>
            <el-input
              ref="amountInput"
              slot="reference"
              type="number"
              v-model="amount"
              placeholder="0.00"
              @focus="amountPopover"/>
          </el-popover>
        </div>
        <div>
          <el-select v-model="value" multiple placeholder="Select Token" size="small">
            <el-option
              v-for="item in tokens"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              >
              <div class="flex">
                <span>{{ item.label }}</span>
                <img style="width: 20px" :src="item.img" :alt="item.name"/>
              </div>
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="calculator-choose">
        <p>Select up to six nodes</p>
        <el-row :gutter="40">
          <el-col :span="8">
            <Choose :index="0" :addNode="addNode"/>
          </el-col>
          <el-col :span="8">
            <Choose :index="1" :addNode="addNode"/>
          </el-col>
          <el-col :span="8">
            <Choose :index="2" :addNode="addNode"/>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="8">
            <Choose :index="3" :addNode="addNode"/>
          </el-col>
          <el-col :span="8">
            <Choose :index="4" :addNode="addNode"/>
          </el-col>
          <el-col :span="8">
            <Choose :index="5" :addNode="addNode"/>
          </el-col>
        </el-row>
      </div>
      <div class="calculator-btn">
        <el-button :disabled="!amount" @click="calculate">Calculate</el-button>
      </div>
    </div>

    <div class="Container">
      <p v-show="showRewards" class="title">Estimated Annual Yield</p>
      <RewardTable v-show="showRewards" :tokens="value"/>
      <RewardChart v-show="showRewards"/>
    </div>
  </div>
</template>

<script>
  import Choose from '@/components/calculator/Choose';
  import RewardTable from '@/components/calculator/RewardTable';
  import RewardChart from '@/components/calculator/RewardChart';
  import { mapState } from 'vuex';

  export default {
    name: 'calculator',
    components: {
      Choose,
      RewardTable,
      RewardChart,
    },
    data() {
      return {
        popoverVisible: false,
        isCalculate: false,
        amount: '',
        nodes: [{ val: '' }, { val: '' }, { val: '' }, { val: '' }, { val: '' }, { val: '' }],
        showRewards: false,
        value: [],
      };
    },
    created() {
      this.$store.dispatch('nodes/getNodeList');
      this.$store.dispatch('nodes/getTokensList');
    },
    computed: {
      ...mapState('nodes', {
        calculateReady: 'calculateReady',
        tokensList: 'tokensList',
      }),
      ...mapState('global', {
        priceUsd: 'price',
      }),
      tokens() {
        const temp = [];
        if (this.tokensList.length > 0) {
          this.tokensList.map((item) => {
            temp.push({
              value: item.name,
              label: item.name,
              img: item.logo,
            });
          });
        }
        return temp;
      },
    },
    methods: {
      amountPopover() {
        if (this.isCalculate && !this.amount) {
          this.popoverVisible = true;
          setTimeout(() => {
            this.popoverVisible = false;
            this.isCalculate = false;
          }, 3000);
        }
      },
      addNode(index, val) {
        this.nodes[index].val = val;
      },
      calculate() {
        if (!this.amount) {
          this.isCalculate = true;
          this.$refs.amountInput.focus();
          this.showRewards = false;
          return;
        }
        const { nodes } = this;
        const len = nodes.length;
        const idList = [];
        for (let i = 0; i < len; i += 1) {
          const item = nodes[i];
          if (item.val !== '') {
            idList.push(item.val);
          }
        }
        if (!idList.length) {
          this.$message.error('Please select at least one node');
          this.showRewards = false;
          return;
        }
        this.showRewards = true;
        this.$store.commit('nodes/calculateReward', {
          idList,
          amount: this.amount,
          priceUsd: this.priceUsd,
          token: this.value,
        });
        setTimeout(() => {
          const $item = document.querySelector('.calculator-btn');
          let offset = window.scrollY;
          const t = setInterval(() => {
            offset += 8;
            window.scrollTo(0, offset);
            if (offset >= $item.offsetTop + 45 || document.documentElement.clientHeight
              + window.scrollY === document.body.scrollHeight) {
              clearInterval(t);
            }
          }, 1);
        }, 200);
      },
    },
  };
</script>

<style lang="scss">
  .calculator {
    // margin-bottom: -71px;
    padding-bottom: 0;
    font-family: Verdana, sans-serif;
    color: #323233;
    min-width: 1220px;
    &-title {
      text-align: center;
      font-size: 32px;
      font-family: Verdana-bold, sans-serif;
      background: #F7F7FA;
      height: 240px;
      padding-top: 60px;
      box-sizing: border-box;
    }

    &-card{
      width: 1220px;
      height: 505px;
      margin: 0 auto;
      border: 1px solid #F2F2F5;
      box-shadow: 10px 10px #F2F2F5;
      padding: 30px 40px 40px 40px;
      box-sizing: border-box;
      position: relative;
      bottom: 71px;
      background: white;
    }
    &-top{
      border-bottom: 1px solid #F2F2F5;
      display: flex;
      justify-content: space-between;
    }

    &-amount {
      height: 106px;
      // border-bottom: 1px solid #F2F2F5;
      p {
        font-size: 17px;
      }
      input {
        -webkit-appearance: none;
        -moz-appearance: none;
        border: none;
        font-size: 36px;
        padding-left: 0;
        margin-top: 10px;
        color: #323233;
      }
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }
    }

    &-choose {
      margin-top: 30px;
      p{
        font-size: 17px;
      }
    }

    &-btn {
      margin-top: 40px;
      text-align: center;
      button {
        background-color: #FF8837;
        width: 353px;
        outline: none;
        color: #fff;
        font-size: 17px;
        font-weight: bold;
        height: 56px;
        border-radius: 0;
        border: none;
      }
      button:hover, button:focus {
        background-color: #FF8837;
        color: #fff;
      }

       .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
        cursor: not-allowed;
        background-color: #FF8837;
        opacity: 0.5;
        color: white;
      }
    }

    .el-row {
      margin-top: 30px;
    }

    .title{
      font-size: 24px;
      font-family: Verdana-bold;
      text-align: center;
      margin-bottom: 40px;
    }
  }

  a.canvasjs-chart-credit {
    display: none;
  }
</style>
